import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("fg_cart") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("fg_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, farm, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.product.id === product.id);
      if (existing) {
        return prev.map((i) => i.product.id === product.id
          ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [...prev, {
        product,
        quantity: qty,
        farm: { id: farm.id, farm_name: farm.farm_name, collection_available: farm.collection_available,
                delivery_available: farm.delivery_available, delivery_fee: farm.delivery_fee,
                delivery_radius_miles: farm.delivery_radius_miles }
      }];
    });
  };

  const updateQty = (productId, qty) => {
    setItems((prev) => prev.map((i) => i.product.id === productId
      ? { ...i, quantity: Math.max(1, qty) } : i));
  };

  const removeItem = (productId) => {
    setItems((prev) => prev.filter((i) => i.product.id !== productId));
  };

  const clearFarm = (farmId) => {
    setItems((prev) => prev.filter((i) => i.farm.id !== farmId));
  };

  const clearCart = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clearFarm, clearCart, count }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
